__turbopack_context__.v({
  "aboutBox": "mIZZza_aboutBox",
  "aboutContainer": "mIZZza_aboutContainer",
  "aboutContent": "mIZZza_aboutContent",
  "aboutTitle": "mIZZza_aboutTitle",
  "actions": "mIZZza_actions",
  "addPill": "mIZZza_addPill",
  "addPill1": "mIZZza_addPill1",
  "delete": "mIZZza_delete",
  "emptyTag": "mIZZza_emptyTag",
  "followCaption": "mIZZza_followCaption",
  "followSlotDesktop": "mIZZza_followSlotDesktop",
  "followSlotMobile": "mIZZza_followSlotMobile",
  "fundingStage": "mIZZza_fundingStage",
  "headerActionSlot": "mIZZza_headerActionSlot",
  "iTag": "mIZZza_iTag",
  "logoTagsContainer": "mIZZza_logoTagsContainer",
  "nameAndActions": "mIZZza_nameAndActions",
  "nameTagContainer": "mIZZza_nameTagContainer",
  "notification": "mIZZza_notification",
  "profile": "mIZZza_profile",
  "statusBadge": "mIZZza_statusBadge",
  "tagDivider": "mIZZza_tagDivider",
  "tags": "mIZZza_tags",
  "tags2": "mIZZza_tags2",
  "tags3": "mIZZza_tags3",
  "tagsContainer": "mIZZza_tagsContainer",
  "tagsRow": "mIZZza_tagsRow",
  "teamLogo": "mIZZza_teamLogo",
  "teamName": "mIZZza_teamName",
});
